<template>
  <div class="rules-control is-flex is-align-items-center" @click.stop>
    <div class="is-flex is-align-items-center" :class="{ 'rules-no-rule': !hasRule }" style="gap: 8px;">
      <b-icon :icon="icon" size="is-small" class="rules-icon"></b-icon>
      <div class="rules-divider"></div>
      <span class="rules-label" @click="$emit('onRuleClicked')">{{ label }}</span>
    </div>
    <div class="rules-divider ml-2"></div>
    <b-button v-if="canRun" type="is-success" size="is-small" icon-left="play" class="rules-run-btn ml-2" @click="$emit('onActionClicked')"></b-button>
    <b-icon v-else icon="plus-circle-outline" size="is-small" class="rules-no-rule-icon ml-2" :class="{ 'rules-no-rule': !hasRule }"></b-icon>
  </div>
</template>

<script>
export default {
  name: "archive-rules-control",
  props: {
    label: {
      type: String,
      default: 'Rules'
    },
    icon: {
      type: String,
      default: 'cog-outline'
    },
    rule: {
      type: Object,
      default: null
    },
    canRun: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasRule() {
      return this.rule !== null && Object.keys(this.rule).length !== 0
    }
  }
}
</script>

<style scoped lang="scss">
.rules-control {
  background-color: #f0f0f0;
  border-radius: 8px;
  padding: 4px 4px 4px 8px;
  gap: 8px;
  cursor: default;
  height: 36px;
  width: fit-content;
}

.rules-no-rule {
  opacity: 0.5;
}

.rules-icon {
  color: #1cab80;
}

.rules-divider {
  width: 1px;
  height: 20px;
  background-color: #ccc;
}

.rules-label {
  font-size: 13px;
  font-weight: 500;
  color: #363636;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: #1cab80;
  }
}

.rules-run-btn {
  border-radius: 50% !important;
  width: 28px;
  height: 28px;
  padding: 0;
}

.rules-no-rule-icon {
  color: #999;
  margin-right: 4px;
}
</style>
